import { StoreSearchFilter } from "./storeSearchFilter/storeSearchFilter.component";

import "./storeSearchFilters.scss";

type StoreSearchFiltersComponentProps = {
    storeFeatures: Array<string>;
    activeSearchFilters: Array<string>;
    onToggleStoreSearchFilter: (feature: string) => void;
};

const StoreSearchFiltersComponent = ({
    storeFeatures,
    activeSearchFilters,
    onToggleStoreSearchFilter
}: StoreSearchFiltersComponentProps) => {
    return (
        <ul className={"store-search-filters list-unstyled m-0"}>
            {storeFeatures.map((storeFeature) => (
                <StoreSearchFilter
                    key={storeFeature}
                    storeFeature={storeFeature}
                    active={activeSearchFilters.includes(storeFeature)}
                    onToggle={onToggleStoreSearchFilter}
                />
            ))}
        </ul>
    );
};

export { StoreSearchFiltersComponent };
